<template>
	<section class="page">
		<div class="top-wrap">
			<div class="top">
				<a class="back" @click="goBack" />
				Coupon
				<a class="more" href="./rewards.html">more</a>
			</div>
		</div>
		
		<div class="content">
			<h3 class="title">Available coupon</h3>
			<div v-if="usable.length" class="con">
				<div class="opt" :class="{'opt1': curIndex == index}" v-for="(item, index) in usable" :key="index" @click="tapCoup(item, index)">
					<div class="opt-fl">
						<h3 v-text="item.giftName" />
						<p>Expire date：<span v-text="item.expireDate" /></p>
					</div>
					<div class="opt-fr" v-text="'PHP '+ item.moneyAmount" />
				</div>
			</div>
			<div v-else class="none">Sorry, no coupon found.</div>
			<h3 class="title page-h">Unavailable coupon</h3>
			<div v-if="unUsable.length" class="con">
				<div class="opt" v-for="(item, index) in unUsable" :key="index">
					<div class="opt-fl">
						<h3 v-text="item.giftName" />
						<p>Expire date：<span v-text="item.expireDate" /></p>
					</div>
					<div class="opt-fr" v-text="'PHP '+ item.moneyAmount" />
				</div>
			</div>
			<div v-else class="none">Sorry, no coupon found.</div>
		</div>

		<div class="bott">
			<div class="bot-fl">Coupon PHP <span v-text="moneyAmount" /></div>
			<div v-if="source == 'loan'" class="bot-fr" @click="done">DONE</div>
			<div v-else class="bot-fr" @click="go">GO APPLY</div>
		</div>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				usable: [],
				unUsable: [],
				curIndex: -1,
				moneyAmount: '',
				exchangeId:"",
				source:this.UTILS.getQueryString("source")
			}
		},
		metaInfo: {
			title: 'coupon'
		},

		mounted: function() {
			let self = this;
			self.getCoupons();
		},
		methods: {
			//返回
			goBack(){
				let self = this;
				let backUrl = self.UTILS.getQueryString("backUrl");
				if(backUrl){
					location.href = `${backUrl}`;
				}else{
					location.href = './index.html';
				}
			},

			//选择优惠券
			tapCoup(item, index){
				var self = this;
				if(self.curIndex == index){
					self.curIndex = -1;
					self.moneyAmount = '';
					self.exchangeId = "";
				}else{
					self.curIndex = index;
					self.moneyAmount = self.usable[index].moneyAmount;
					self.exchangeId = self.usable[index].exchangeId;
				}
			},

			//获取优惠券
			getCoupons(){
				var self = this;
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/coupon/queryCouponList', {
					provideType: 1
				}, function(res){
					self.UTILS.loadGif.hide();
					if(res.code == '0000'){
						self.usable = res.data.usable;
						self.unUsable = res.data.unUsable;
						if(self.usable && self.usable.length){
							let exchangeId = self.UTILS.getParam("exchangeId");
							let curIndex = self.usable.findIndex(item => item.exchangeId === exchangeId);
							self.curIndex = curIndex;
							self.moneyAmount = self.usable[curIndex].moneyAmount;
							self.exchangeId = self.usable[curIndex].exchangeId;
						}
					}else{
						self.UTILS.logStr(res.message);
					}
				});
			},
			
			done(){
				if(this.exchangeId){
					let backUrl = this.UTILS.getQueryString("backUrl");
					this.UTILS.setParam('moneyAmount', this.moneyAmount);
					this.UTILS.setParam('exchangeId', this.exchangeId);
					location.href = `${backUrl}`
				}
				else{
					this.UTILS.removeParam("moneyAmount");
					this.UTILS.removeParam("exchangeId");
					this.UTILS.logStr("plese select the coupon");
				}
			},

			//跳首页
			go(){
				location.href = './index.html';
			}
		}
	}
</script>

<style scoped>
.page{ padding-bottom: 1.1rem;width:100%; height: 100%; background-color:#fff}
.page .top-wrap{display: flex;width: 100%;align-items: center;justify-content: flex-end;background-color: #FD691A;}
.top{ flex: 1;height: 1.4rem; line-height: 1.4rem; text-align: center; font-size: 0.52rem; color: #FCFCF9; background-color: #FD691A; position: relative;}
.back{ width: 0.6rem; height: 0.6rem; background: url(./img/back.png); background-size: cover; position: absolute; left: 0.2rem; top: 0.2rem;}
.more{ line-height: 1.4rem; padding: 0 0.3rem; font-size: 0.36rem; color: #023D75; text-decoration: underline; position: absolute; top: 0; right: 0;}
.page .top-wrap img{width: 0.36rem;}
.page .content{ height: calc(100% - 1.6rem); padding-bottom: 0.1rem; overflow: auto;}
.page .title{ height: 0.54rem; line-height: 0.54rem; font-size: 0.36rem; font-weight: normal; color: #3D3D3D; background: url('./img/icon.png') no-repeat right center; background-size: 4.06rem auto; margin: 0.3rem 0 0 0.3rem;}
.page .page-h{ background-size: 3.6rem auto;}
.opt{ width: 6.18rem; height: 1.4rem; border-radius: 0.1rem; box-shadow: 0.02rem 0.03rem 0.1rem #ffceb4; margin: 0.3rem auto 0 auto;}
.opt1{ border: 0.05rem solid #FD691A;}
.opt-fl{ width: 4.5rem; padding: 0.1rem 0 0 0.2rem; float: left;}
.opt-fl h3{ line-height: 0.6rem; font-size: 0.32rem; font-weight: normal; color: #3D3D3D;}
.opt-fl p{ line-height: 0.4rem; font-size: 0.26rem; color: #3D3D3D;}
.opt-fr{ width: 1.5rem; line-height: 1rem; font-size: 0.26rem; color: #000; float: right; margin-top: 0.2rem;}
.none{ height: 1.8rem; line-height: 1.8rem; text-align: center; font-size: 0.36rem; color: #999;}
.bott{ width: 5.8rem; height: 0.92rem; background: linear-gradient(270deg, #FD691A 0%, #FD691A 37%, #010101 38%, #020202 100%); border-radius: 0.46rem; position: fixed; bottom: 0.16rem; left: 50%; margin-left: -2.9rem;}
.bot-fl{ width: 63%; padding-left: 0.3rem; line-height: 0.92rem; text-align: center; font-size: 0.3rem; color: #FFF; float: left;}
.bot-fr{ width: 37%; line-height: 0.92rem; text-align: center; font-size: 0.32rem; color: #FFF; float: right;}
</style>
